import { render, staticRenderFns } from "./AnaliseDocumentacaoCabecalho.vue?vue&type=template&id=56f02784&scoped=true"
import script from "./AnaliseDocumentacaoCabecalho.vue?vue&type=script&lang=js"
export * from "./AnaliseDocumentacaoCabecalho.vue?vue&type=script&lang=js"
import style0 from "./AnaliseDocumentacaoCabecalho.vue?vue&type=style&index=0&id=56f02784&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f02784",
  null
  
)

export default component.exports